
<template>
  <div class="PacientesDetallePlanesTratamiento">
    <v-card outlined>
      <v-list>
        <div
          v-for="(plan,idxplt) in planes"
          :key="idxplt"
        >
          <v-list-item v-if="plan.realizado_plt==='no'">
            <v-list-item-content>
              <v-list-item-title
                class="nowrap description-text"
                v-text="plan.descripcion_plt"
              />
              <v-list-item-subtitle
                class="nowrap"
                v-text="'Aun no realizado'"
              />
            </v-list-item-content>
          </v-list-item>
          <v-expansion-panels
            v-else
            class="ep-has-no-shadow"
          >
            <v-expansion-panel>
              <v-expansion-panel-header>
                <div class="description-text">{{plan.descripcion_plt}}</div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <div v-if="plan.fecha_realizado_plt && plan.fecha_realizado_plt!='0000-00-00'">
                  Realizado el {{_doDiaMes(plan.fecha_realizado_plt)}}<br><br>
                </div>
                <!-- Componente de odontograma no disponible en clientes-app -->
                <!-- <div v-if="plan.id_odo_plt">
                  <v-btn
                    v-text="'Ver odontograma'"
                    class="primary"
                    @click="showDetalleOdonto = plan.id_odo_plt"
                  />
                  <br><br>
                </div> -->
                <div v-if="plan.nota_evolucion_plt">
                  <strong>Nota de evolución:</strong><br>
                  <div class="description-text mt-2" v-text="plan.nota_evolucion_plt"></div>
                </div>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
          <v-divider v-if="idxplt+1<planes.length" />
        </div>
      </v-list>
    </v-card>
    <!-- <OdontogramaDetalle v-model="showDetalleOdonto" /> -->
  </div>
</template>
<script>
import forms from "@/mixins/forms.js";
import dates from "@/mixins/dates.js";
// import OdontogramaDetalle from "@/components/odontograma/OdontogramaDetalle.vue";
export default {
  name: "PacientesDetallePlanesTratamiento",
  mixins: [forms, dates],
  // components: {
  //   OdontogramaDetalle,
  // },
  props: {
    id: [String, Number],
  },
  data() {
    return {
      planes: [],
      paciente: null,
      showDetalleOdonto: null,
    };
  },
  methods: {
    _getPlanesTratamientos() {
      if (this.id) {
        this._getThings("planesdetratamiento/" + this.id, "planes");
      }
    },
  },
  created() {
    this.paciente = this.id;
    this._getPlanesTratamientos();
  },
  watch: {
    id() {
      this.paciente = this.id;
      this._getPlanesTratamientos();
    },
  },
};
</script>
<style scoped>
.description-text {
  white-space: pre-wrap;
  word-wrap: break-word;
  font-family: inherit;
  line-height: 1.5;
}

.v-list-item__title.description-text {
  white-space: pre-wrap !important;
  height: auto !important;
}
</style>

